<template>
    <common-modal width="huge">
        <common-content-wrapper class="finish-early-modal" width="medium">
            <common-content-spacer height="medium">
                <div class="modal-header">
                    <span class="modal-header--text">
                        {{ $t('components.reservations.reservation_status.modal.finish_early_heading') }}
                    </span>
                </div>
                <div class="modal-header">
                    <p>{{ $t('components.reservations.reservation_status.modal.finish_early_description') }}</p>
                </div>
                <div class="modal-form">
                    <form-wrapper @form-submit="submit">
                        <form-row>
                            <form-cell width="half">
                                <select-input
                                    :formData="data"
                                    :label="$t('components.reservations.reservation_status.modal.finish_early_chose')"
                                    :placeholder="$t('forms.offer.create_offer.fields.appointment_length.placeholder')"
                                    :isRequired="true"
                                    :options="appointmentLengthOptions"
                                    valuePath="appointmentLength"
                                    @change="change"
                                ></select-input>
                            </form-cell>
                        </form-row>
                        <template #footer>
                            <common-buttons>
                                <common-button
                                    type="primary"
                                    :isProcessing="false"
                                    :label="$t('common.microcopy.save')"
                                ></common-button>
                            </common-buttons>
                        </template>
                    </form-wrapper>
                </div>
            </common-content-spacer>
        </common-content-wrapper>
    </common-modal>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import AppointmentLengthEnum from 'enums/appointment_length.enum'

    export default {
        mixins: [FormMixin],

        props: {
            headingText: { type: String, default: '' },
            done: { type: String, default: '' },
            maxMinutesAvailable: { type: Number, default: 500 },
        },

        computed: {
            appointmentLengthOptions() {
                return AppointmentLengthEnum[this.$i18n.locale].filter((item) => item.value <= this.maxMinutesAvailable)
            },
        },

        methods: {
            submit() {
                const data = {
                    minutes: this.data.appointmentLength,
                }
                this.emitEvent({ name: 'minutes-chosen', payload: data })
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    .finish-early-modal {
        min-height: 400px !important;
    }
    .modal-header {
        display: flex;
        justify-content: center;
        align-items: center;
        &--text {
            line-height: $line-height--heading;
            font-size: 19px;
            font-weight: 700;
        }
    }

    .form-row {
        justify-content: center;
    }

    .finish-modal {
        display: block;

        button {
            display: block;
            margin-left: 0px;
            margin-bottom: 10px;
            width: 100%;
        }
    }
</style>
